module.exports = __webpack_public_path__ + "img/7.9f9be9de.png";